import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';

/**
 * Native Splash Screen Controller
 */
export const NativeSplash = {
  /**
   * Hide the splash screen smoothly
   * @param {number} fadeOutDuration Fade out duration in milliseconds
   */
  hide: async (fadeOutDuration = 300) => {
    if (Capacitor.isNativePlatform()) {
      try {
        await SplashScreen.hide({
          fadeOutDuration
        });
      } catch (e) {
        console.warn('Failed to hide splash screen', e);
      }
    }
  },

  /**
   * Show splash screen manually
   */
  show: async (autoHide = false, fadeInDuration = 200, showDuration = 3000) => {
    if (Capacitor.isNativePlatform()) {
      try {
        await SplashScreen.show({
          autoHide,
          fadeInDuration,
          showDuration
        });
      } catch (e) {
        console.warn('Failed to show splash screen', e);
      }
    }
  }
};

export default NativeSplash;
